import { Component } from "@angular/core";

@Component({
  selector: "core-ui-input-password",
  templateUrl: "./input-password.component.html",
  styleUrls: ["./input-password.component.scss"],
  standalone: false
})
export class InputPasswordComponent {}  